// src/data.js

export const projects = [
  {
    title: "MHUTEMP",
    subtitle: "Next js + Node js",
    stack: ['Next js', 'Node js', 'Mongo DB'],
    description:
      "MHUTEMP is an open-source IoT-based solution designed for real-time monitoring of temperature and humidity levels in critical healthcare equipment such as blood bank refrigerators and vaccine storage units.",
    image: "mhutemp",
    link: "https://bio-data-nextjs.netlify.app/",
    github: "https://github.com/storres20/bio-data-nextjs",
    youtube: ""
  }
];

export const skills = [
  {
    id: "1",
    subtitle: "HTML",
  },
  {
    id: "2",
    subtitle: "CSS",
  },
  {
    id: "3",
    subtitle: "Javascript",
  },
  {
    id: "4",
    subtitle: "React js",
  },
  {
    id: "5",
    subtitle: "Next js",
  },
  {
    id: "6",
    subtitle: "Node js",
  },
  {
    id: "7",
    subtitle: "Tailwind CSS",
  },
  {
    id: "8",
    subtitle: "MongoDB",
  },
  {
    id: "9",
    subtitle: "Git",
  },
  {
    id: "10",
    subtitle: "Github",
  },
];

export const testimonials = [
  {
    id: "1",
    name: "React Reserve",
    company: "MERN Stack",
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "project1",
    link: "https://reactbootcamp.com",
  },
  {
    id: "2",
    name: "React Tracks",
    company: "React and Python",
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "project2",
    link: "https://reedbarger.com",
  },
  {
    id: "3",
    name: "DevChat",
    company: "React and Firebase",
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "project3",
    link: "https://jsbootcamp.com",
  },
  {
    id: "4",
    name: "Epic Todo App",
    company: "React Hooks",
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "project4",
    link: "https://pythonbootcamp.com",
  },
];